<template>
  <!-- "Foreplay tools": connects the tool names to what they do. Each tool is
  a light chip with a dark app-icon tile — the sidebar's animated sprites are
  designed for dark backgrounds, so only the tile is dark, not the whole strip.
  Hovering plays the sidebar animation and shows a one-liner. -->
  <div>
    <BaseText
      type="heading"
      size="overline"
      class="text-text-subdued uppercase"
    >
      {{ title }}
    </BaseText>
    <!-- Phone: no hover or navigation, so the one-liners show inline -->
    <div
      v-if="phone"
      class="mt-1.5 flex flex-col gap-2"
    >
      <div
        v-for="tool in tools"
        :key="tool.key"
        class="flex items-center gap-2.5"
      >
        <div class="w-10 h-10 flex-shrink-0 rounded-lg bg-background-loud flex items-center justify-center overflow-hidden">
          <AnimatedProductNavIcon
            v-if="tool.key !== 'mcp'"
            :product="tool.key"
            :size="40"
            :is-hovered="false"
          />
          <MCPIcon
            v-else
            class="text-white opacity-70"
          />
        </div>
        <div class="min-w-0">
          <BaseText
            type="label"
            size="sm"
            class="text-text-loud"
          >
            {{ tool.name }}
          </BaseText>
          <BaseText
            type="body"
            size="xs"
            class="text-text-subdued"
          >
            {{ tool.blurb }}
          </BaseText>
        </div>
      </div>
    </div>
    <div
      v-else
      class="mt-1.5 flex items-center gap-2 flex-wrap"
    >
      <BaseTooltipV2
        v-for="tool in tools"
        :key="tool.key"
        :text="tool.blurb"
        position="top"
        alignment="start"
        :max-default-tooltip-width="280"
      >
        <button
          class="flex items-center gap-2.5 p-1 pr-3.5 rounded-xl border bg-white transition duration-100"
          :class="hoveredTool === tool.key ? 'border-border-hover shadow-sm' : 'border-border-normal'"
          @mouseenter="hoveredTool = tool.key"
          @mouseleave="hoveredTool = null"
          @click="openTool(tool)"
        >
          <div class="w-10 h-10 flex-shrink-0 rounded-lg bg-background-loud flex items-center justify-center overflow-hidden">
            <AnimatedProductNavIcon
              v-if="tool.key !== 'mcp'"
              :product="tool.key"
              :size="40"
              :is-hovered="hoveredTool === tool.key"
            />
            <MCPIcon
              v-else
              class="text-white transition-opacity duration-100"
              :class="hoveredTool === tool.key ? 'opacity-100' : 'opacity-70'"
            />
          </div>
          <BaseText
            type="label"
            size="sm"
            class="text-text-loud"
          >
            {{ tool.name }}
          </BaseText>
          <template v-if="tool.descriptor">
            <div class="w-px h-3.5 bg-border-normal" />
            <BaseText
              type="body"
              size="sm"
              class="text-text-subdued"
            >
              {{ tool.descriptor }}
            </BaseText>
          </template>
        </button>
      </BaseTooltipV2>
    </div>
  </div>
</template>

<script>
import posthog from 'posthog-js'
import AnimatedProductNavIcon from '../globals/Icons/SidebarIcons/AnimatedProductNavIcon.vue'
import MCPIcon from '../globals/Icons/ApiIcons/MCPIcon.vue'

export default {
  name: 'SetupToolsBar',
  components: {
    AnimatedProductNavIcon,
    MCPIcon
  },
  props: {
    // [{ key, name, descriptor?, blurb, route }] from setupContent
    tools: {
      type: Array,
      required: true
    },
    sectionId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Foreplay tools'
    },
    phone: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hoveredTool: null
    }
  },
  methods: {
    openTool (tool) {
      posthog.capture('Setup Tool Clicked', { tool: tool.key, section: this.sectionId })
      if (tool.route) this.$router.push(tool.route).catch(() => {})
    }
  }
}
</script>
